module.exports = __webpack_public_path__ + "img/frozen_mixed_vegetable.ac4113e7.jpg";